import i18next from 'i18next';
const prepareTerms = (): string[] => {
  const termsCondition = [] as string[];

  let termIndex = 1;
  const termsKeyPath = 'pages.services.transferMilage.sections.terms.list.';
  while (!i18next.t(`${termsKeyPath}${termIndex}`).includes(`${termsKeyPath}${termIndex}`)) {
    termsCondition.push(i18next.t(`${termsKeyPath}${termIndex}`));
    termIndex++;
  }
  return termsCondition;
};

export const buyMilageTerms: string[] = prepareTerms();
